import { useEffect, useState } from "react";
import { ToolsPanelBody } from "./ToolsPanel";
import { apiFetch } from "@/lib/backend";

export function ToolsView({ onExit }: { onExit: () => void }) {
  const [hostname, setHostname] = useState<string | null>(null);

  useEffect(() => {
    apiFetch("/api/health")
      .then((r) => (r.ok ? r.json() : null))
      .then((info) => {
        if (info) setHostname(`${info.hostname} (${info.platform}/${info.arch})`);
      })
      .catch(() => {});
  }, []);

  return (
    <div className="fixed inset-y-0 right-0 z-40 flex flex-col bg-background" style={{ left: "var(--sb-w, 0px)" }}>
      <div data-tauri-drag-region className="flex items-center gap-3 border-b px-4 py-3" style={{ paddingTop: "calc(0.75rem + var(--titlebar-h, 0px) + env(safe-area-inset-top))" }}>
        <button onClick={onExit} className="rounded-md p-1.5 text-muted-foreground hover:text-foreground" title="Back to chat">
          <i className="fa-solid fa-arrow-left" />
        </button>
        <h1 className="text-base font-semibold">Tools</h1>
      </div>

      <div className="flex min-h-0 flex-1 flex-col">
        <div className="flex-1 overflow-y-auto p-4">
          <div className="mx-auto w-full max-w-3xl">
            <ToolsPanelBody />
          </div>
        </div>
        {hostname && (
          <div className="border-t px-4 py-2 text-[11px] text-muted-foreground flex items-center gap-1.5">
            <i className="fa-solid fa-server" />
            <span className="truncate">{hostname}</span>
          </div>
        )}
      </div>
    </div>
  );
}
